import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@fontsource-variable/inter'
import '@fontsource-variable/jetbrains-mono'
import './index.css'
import { router } from './App.tsx'
import { queryClient } from "@/lib/query-client"
import { RouterProvider } from '@tanstack/react-router'
import { QueryClientProvider } from '@tanstack/react-query'
import { registerGlobalRuntimeErrorHandlers } from '@/observability/runtime-error-handlers'
import { initOpenReplay } from '@/observability/openreplay-setup'
import { initSentry, maybeRunSentrySmokeTest } from '@/observability/sentry-setup'

initSentry()
initOpenReplay()
registerGlobalRuntimeErrorHandlers()
maybeRunSentrySmokeTest()

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element not found')
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
)
